import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  eyebrow?: string;
  className?: string;
}

export function PageHeader({ title, description, actions, eyebrow, className }: PageHeaderProps) {
  const { t } = useLanguage();
  return (
    <div className={cn("flex flex-col gap-4 pb-6 sm:flex-row sm:items-end sm:justify-between", className)}>
      <div className="flex flex-col gap-1">
        {eyebrow && (
          <span className="text-xs font-medium uppercase tracking-wider text-primary">{t(eyebrow)}</span>
        )}
        <h1 className="font-display text-2xl font-semibold tracking-tight sm:text-3xl">{t(title)}</h1>
        {description && <p className="max-w-2xl text-sm text-muted-foreground">{t(description)}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
